<template>
  <div class="content">
    <div class="header">
      <p style="font-size: 10pt" v-html='$t("message.survey_header_text")'/>
    </div>
    <el-container class="container" v-for="feature in features" :key="feature.id">
      <el-container>
      <el-aside style='width: 90px;height: 90px'>
        <img class="icon" :src="getImageUrl(feature.icon)" :alt="'Secret Vault ' + feature.title + ' feature icon'">
      </el-aside>
      <el-main>
        <el-header style="height: 30px">
          <span class="title">{{ feature.title }}</span>
        </el-header>
        <p class="description">{{ feature.content }}</p>
      </el-main>
      </el-container>
      <el-footer height='28px'>
        <el-button class="like_button" type="primary" @click="onLike(feature)">
          <img v-if="feature.isLike" :src="getImageUrl('icon_like_solid.png')" alt="" style="width: 16px; vertical-align:middle;"/>
          <img v-if="!feature.isLike" :src="getImageUrl('icon_like_hollow.png')" alt="" style="width: 16px; vertical-align:middle;"/>
          {{ $t("message.survey_button_like") }}
        </el-button>
      </el-footer>
      <i v-if="feature.status==1" class="icon-status s-released"></i>
    </el-container>
    <a class="link" size="mini" type="primary" @click="onFeedback">
      <strong v-html='$t("message.survey_wanted_features")'></strong>
    </a>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        features: [{
          id: '6',
          icon: 'icon_change_icon.png',
          title: this.$i18n.t('message.survey_6_title'),
          content: this.$i18n.t('message.survey_6_description'),
          likeCount: 0,
          isLike: 0,
          status: 0
        }, {
          id: '1',
          icon: 'icon_break_in.png',
          title: this.$i18n.t('message.survey_1_title'),
          content: this.$i18n.t('message.survey_1_description'),
          likeCount: 0,
          isLike: 0,
          status: 0
        }, {
          id: '2',
          icon: 'icon_gesture.png',
          title: this.$i18n.t('message.survey_2_title'),
          content: this.$i18n.t('message.survey_2_description'),
          likeCount: 0,
          isLike: 0,
          status: 0
        }, {
          id: '3',
          icon: 'icon_cloud_drive.png',
          title: this.$i18n.t('message.survey_3_title'),
          content: this.$i18n.t('message.survey_3_description'),
          likeCount: 0,
          isLike: 0,
          status: 0
        }, {
          id: '4',
          icon: 'icon_album_password.png',
          title: this.$i18n.t('message.survey_4_title'),
          content: this.$i18n.t('message.survey_4_description'),
          likeCount: 0,
          isLike: 0,
          status: 0
        }, {
          id: '5',
          icon: 'icon_album_cover.png',
          title: this.$i18n.t('message.survey_5_title'),
          content: this.$i18n.t('message.survey_5_description'),
          likeCount: 0,
          isLike: 0,
          status: 0
        }]
      }
    },
    watch: {
      "$route.path": {
        handler: function(newVal, oldVal) {
          if (newVal === "/survey") {
            let ids = new Array()
            for (let i=0; i<this.features.length; i++) {
              ids.push(this.features[i].id)
            }
            this.getFeatures(ids)
          }
        },
        immediate: true
      }
    },
    methods: {
      getImageUrl(icon) {
        return new URL(`../images/${icon}`, import.meta.url).href
      },
      getFeatures(ids) {
        if (import.meta.env.SSR) return

        let params = {
          'uuid': this.$route.query.uuid,
          'ids': ids
        }

        this.$store
        .dispatch('getFeaturesAjax', params)
        .then(response => {
          if (!response || response.code !== 0) return
          this.features.forEach((item, index) => {
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].ID == item.id) {
                item.likeCount = response.data[i].LIKE_COUNT
                item.isLike = response.data[i].IS_LIKE
                item.status = response.data[i].STATUS
              }
            }
          })
        })
      },
      onLike(feature) {
        // like取反
        feature.isLike = !feature.isLike

        // 构造参数
        let params = {
          'uuid': this.$route.query.uuid,
          'feature_id': feature.id,
          'like_status': feature.isLike ? '1' : '0'
        }
        this.$store
        .dispatch('likeAjax', params)
        .then(response => {
          if (response.code !== 0) {
            this.$message.error(response.message)
          }
        })
        .catch(err => {
          this.$message.error(this.$i18n.t('message.feedback_tip_submit_error'))
        })
      },
      onFeedback() {
        let query = this.$route.query
        query['type'] = 2
        this.$router.push({
          path: '/feedback',
          query: query
        })
      }
    }
  }
</script>
<style scoped lang="scss">
.content {
  width: 100%;
  height: 100%;
}

.header {
  background-color: #eee;
  border-bottom: 1px solid #c8e7ff;
  margin: 0 0px 10px;
  padding: 10px 20px;
  box-shadow: 0px 0px 5px 0px
    rgba(173, 173, 224, 0.6);
}

.container {
  background-color: #eee;
  border: 1px solid #c8e7ff;
  border-radius: 6px;
  margin: 0 10px 10px;
  box-shadow: 0px 3px 10px 0px
    rgba(173, 173, 224, 0.6);
}

.el-main {
  padding: 0 4px;
  height: 85px;
  border-bottom: 1px solid #c8e7ff;
}

.el-header {
  padding: 0;
}

.el-footer {
  padding: 0 5px;
}

.title {
  font-size: 11pt;
  line-height: 30px;
}

.description {
  font-size: 8pt;
}

.icon {
  width: 78px;
  height: 78px;
  margin: 5px 5px 0 5px;
  border-radius: 4px;
}

.icon-status {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  border-top-right-radius: 4px;
}
.s-released {
  background: url("./../images/status_released.png") no-repeat center;
  background-size: 100% 100%;
}

.like_button {
  width: 80px;
  height: 22px;
  padding: 0;

  > span {
    vertical-align: top;
  }
}

.link {
  display: block;
  margin: 20px 20px 50px;
}
</style>
